// src/components/KakaoChatButton.tsx
import { useRef, type FC } from "react";
import {
  getKakaoChatUrl,
  isValidKakaoPfUrl,
  openExternalUrl,
} from "../lib/openExternal";

const KakaoChatButton: FC = () => {
  const lastTapRef = useRef(0);

  const onClick = () => {
    const now = Date.now();
    if (now - lastTapRef.current < 600) return;
    lastTapRef.current = now;

    const url = getKakaoChatUrl();

    if (!isValidKakaoPfUrl(url)) {
      alert("카카오톡 채널 주소가 잘못 설정되어 있습니다. 관리자에게 문의해 주세요.");
      return;
    }

    openExternalUrl(url);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="
        fixed right-6 z-50
        bottom-[calc(env(safe-area-inset-bottom)+88px)] md:bottom-12
        flex h-14 w-14 items-center justify-center
        rounded-full bg-[#fee500] shadow-lg
        border border-black/10
        hover:brightness-105 active:scale-95
        transition
      "
      aria-label="카카오톡 채널로 문의하기"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black text-xs font-semibold text-[#fee500]">
        Ch
      </span>
    </button>
  );
};

export default KakaoChatButton;
